import { render, staticRenderFns } from "./TableFieldWrapper.vue?vue&type=template&id=22dc2092&"
import script from "./TableFieldWrapper.vue?vue&type=script&lang=js&"
export * from "./TableFieldWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports